import { useEffect, useState } from "react";
import { CookieBanner } from "@schlomoh/react-cookieconsent";
import Cookies from "js-cookie";

export const InkrivCookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 });
    setShowBanner(false);
  };

  const handleDecline = () => {
    Cookies.set("cookieConsent", "declined", { expires: 365 });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <CookieBanner
      acceptButtonText="Accept All"
      declineButtonText="Decline"
      headingColor="white"
      paragraphColor="grey"
      containerStyle={{ backgroundColor: "#121212" }}
      primaryButtonStyle={{
        borderRadius: "6px",
        backgroundColor: "#E63C3C",
        color: "white",
        padding: "10px 20px",
      }}
      secondaryButtonStyle={{
        borderRadius: "6px",
        backgroundColor: "#373F51",
        color: "white",
        padding: "10px 20px",
      }}
      onAccept={handleAccept}
      onDecline={handleDecline}
      infoContent={
        <div>
          <h3 style={{ color: "white" }}>We use cookies on Inkriv</h3>
          <p style={{ color: "grey" }}>
            Cookies help personalize content and improve your writing
            experience. We promise not to do anything creepy.
          </p>
        </div>
      }
    />
  );
};
